/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import dayjs from 'dayjs'
import {useState} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {CreateAppModal} from '../../../partials'
import {useLayout} from '../../core'
import {DefaultTitle} from '../header/page-title/DefaultTitle'

const Toolbar1 = () => {
  const {currentUser} = useAuth()
  const {classes} = useLayout()
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)

  return (
    <>
      <div className='toolbar' id='kt_toolbar'>
        {/* begin::Container */}
        <div
          id='kt_toolbar_container'
          className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}
        >
          <DefaultTitle />

          {/* begin::Actions */}
          <div className='d-flex align-items-center py-1'>
            {/* begin::Wrapper */}
            <div className='me-4'>
              {/* begin::Menu */}
              {/* <a
                href='#'
                className='btn btn-sm btn-flex btn-light btn-active-primary fw-bolder'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <KTSVG
                  path='/media/icons/duotune/general/gen031.svg'
                  className='svg-icon-5 svg-icon-gray-500 me-1'
                />
                Academic Year:{' '}
                {currentUser?.academic_year?.start &&
                  dayjs(currentUser?.academic_year.start).format('MMM YYYY')}{' '}
                -
                {currentUser?.academic_year?.end &&
                  dayjs(currentUser?.academic_year.end).format('MMM YYYY')}
              </a> */}

              {/* end::Menu */}
            </div>
            {/* end::Wrapper */}

            {/* begin::Button */}

            <span className='btn btn-sm btn-primary cursor-pointer fw-bolder'>
              Academic Session:{' '}
              {currentUser?.academic_year?.start &&
                dayjs(currentUser?.academic_year.start).format('MMM YYYY')}{' '}
              -{' '}
              {currentUser?.academic_year?.end &&
                dayjs(currentUser?.academic_year.end).format('MMM YYYY')}
            </span>
            {/* end::Button */}
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Container */}
      </div>
      <CreateAppModal show={showCreateAppModal} handleClose={() => setShowCreateAppModal(false)} />
    </>
  )
}

export {Toolbar1}
